/**
 * Shared constants for resident messages/property chat
 */

export type MessageSortOption = 'latest' | 'aToZ' | 'zToA';

export interface SortOptionConfig {
  key: MessageSortOption;
  label: string;
}

/**
 * Sort options for conversation lists
 * Used by both mobile (ChatListHeader) and desktop (MessagesScreen)
 */
export const MESSAGE_SORT_OPTIONS: readonly SortOptionConfig[] = [
  { key: 'latest', label: 'Sort by latest' },
  { key: 'aToZ', label: 'Sort by subject (a-z)' },
  { key: 'zToA', label: 'Sort by subject (z-a)' },
] as const;

/**
 * Get the label for a sort option key
 */
export const getSortOptionLabel = (key: MessageSortOption): string => {
  return MESSAGE_SORT_OPTIONS.find((opt) => opt.key === key)?.label || 'Sort by latest';
};
